import {
  getCart,
  deleteFromCart,
  addToCart,
  submitCheckout,
  clearCart,
} from '@/api'
import {
  CartResponse,
  CheckoutResponse,
  GroupedCartResponse,
} from '@/types/cart'
import { CartRecommendationProduct } from '@/types/recommendation'
import { useInvalidateOnSuccessMutation } from '@/utils'
import { useQuery, UseQueryOptions } from 'react-query'

const keys = {
  cart: 'cart',
  count: 'count',
}

export const parseCartData = (data: CartResponse): GroupedCartResponse => {
  const allItems = data?.map((entry) => entry.items).flat()

  const groupedItemsByLocation: GroupedCartResponse = allItems.reduce(
    (acc: GroupedCartResponse, item: CartRecommendationProduct) => {
      const locationId = item.locationId
      if (!acc[locationId]) {
        acc[locationId] = []
      }
      acc[locationId].push(item)
      return acc
    },
    {},
  )

  return groupedItemsByLocation
}

export const useCart = (
  options?: UseQueryOptions<CartResponse, unknown, GroupedCartResponse>,
) => {
  return useQuery<CartResponse, unknown, GroupedCartResponse>(
    keys.cart,
    getCart,
    {
      select: parseCartData,
      ...options,
    },
  )
}

export const useClearCart = () =>
  useInvalidateOnSuccessMutation(keys.cart, clearCart)

export const useDeleteFromCart = () =>
  useInvalidateOnSuccessMutation(keys.cart, (recommendationProductId) =>
    deleteFromCart(recommendationProductId),
  )
export const useAddProductToCart = () =>
  useInvalidateOnSuccessMutation(keys.cart, (id) => addToCart(id))

export const useSubmitCheckout = () =>
  useInvalidateOnSuccessMutation<CheckoutResponse>(
    [keys.cart, 'location'],
    ({ paymentId, items }) => submitCheckout({ paymentId, items }),
  )
